// Core
import React, { useState, useEffect } from "react";

// Contrib
import { Grid, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams, Link } from "react-router-dom";

// Custom
import Searchbar from "./searchbar";

function SearchPage(props) {
   const [searchResults, setSearchResults] = useState();
   let { searchQuery } = useParams();

   useEffect(() => {
      fetch("https://search.grants.nih.gov/faq/api/search/question/" + searchQuery)
         .then((r) => r.json())
         .then((r) => {
            var results = r.questions.filter((item) => item.Category_Number === 35);
            setSearchResults(results);
         });
   }, []);

   if (!searchResults) return;

   return (
      <>
         <div className="greenHeader headerBg">
            <h1></h1>
            <h2>
               <strong>FAQs Search Results</strong>
            </h2>
            <br />
            <Searchbar />
         </div>
         <Grid>
            <Row>
               <Col md={12}>
                  <Link to={"/"} className="text-primary" style={{ marginBottom: "30px", display: "block" }}>
                     Back to <strong>All FAQs</strong>
                  </Link>
                  {searchResults.length != 0 && (
                     <div>
                        <h2>
                           Showing search results for "<span style={{ color: "#ffa827" }}>{searchQuery}</span>"
                        </h2>
                        <br />
                        <br />
                        <br />
                     </div>
                  )}
                  {!searchResults.length && (
                     <div style={{ textAlign: "center" }}>
                        <img src={process.env.PUBLIC_URL + "/assets/no-results.svg"} />
                        <br />
                        <br />
                        <strong>No search results</strong>
                        <br />
                        Please try again with a different search term
                     </div>
                  )}
                  <div className="itemsView list">
                     {searchResults.map((item, i) => (
                        <Link to={"/" + item.AlphaHeadertext.replace(/\s+/g, "-") + "/" + item.Question.replace(/\s+/g, "-")} key={item.ID}>
                           <strong>
                              <FontAwesomeIcon icon="search" style={{ marginRight: "20px" }} /> {item.Question}
                           </strong>
                           <FontAwesomeIcon icon="arrow-right" style={{ fontSize: "2em", color: "#000" }} />
                        </Link>
                     ))}
                  </div>
               </Col>
            </Row>
         </Grid>
      </>
   );
}

export default SearchPage;
